import { useMutation } from "@tanstack/react-query";
import { useRef } from "react";

import { BrandRepository } from "@/repositories/brand";
import { BrandFormData } from "@/schemas/brand-form.schema";

export const useCreateBrand = () => {
  const brandRepository = useRef(new BrandRepository());

  return useMutation({
    mutationFn: (data: BrandFormData) => brandRepository.current.add(data),
  });
};
